import { Button as ButtonAntD } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-select-item.ant-select-item-option.ant-select-item-option-selected {
    background-color: ${({ theme }) => theme.hoveredDiv};
  }

  .ant-page-header-back-button:focus,
  .ant-page-header-back-button:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Button = styled(ButtonAntD)`
  height: 50px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 3px;

  &.ant-btn-primary {
    background-color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }

  &.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous) {
    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    }
  }
`;
